import type { ReactNode } from 'react';
import { SummaryCtx, type StudioSummary } from './studioHooks';

export function StudioSummaryProvider({ value, children }: { value: StudioSummary | null; children: ReactNode }) {
  return <SummaryCtx.Provider value={value}>{children}</SummaryCtx.Provider>;
}
